export default "__VITE_ASSET__8610295c__"